export const ROUTES = {
  AUTH_PHONE_NUMBER: "/auth/phone-number",
  AUTH_PHONE_OTP: "/auth/phone-otp",
  ONBOARDING_PERSONAL_DETAILS: "/onboarding/personal-details",
  ONBOARDING_PROFILE_PIC: "/onboarding/profile-pic",
  ONBOARDING_PROFESSIONAL_DETAILS: "/onboarding/professional-details",
  ONBOARDING_SOCIALS: "/onboarding/socials",
  HOME: "/home",
  USER_PROFILE: "/home/user/:user_id",
  USER_ACTIVITY: "/home/user/:user_id/activity",
  ACADEMY_PARENT: "/academy/*",
  ACADEMY_DEFAULT: "/academy",
  ACADEMY_COURSES: "/academy/courses",
  ACADEMY_LIVESTREAM: "/academy/livestream",
  ACADEMY_NEWS: "/academy/news",
  ACADEMY_COMICS: "/academy/comics",
  ACADEMY_MODULE_COMPLETED: "/module-completed",
  COURSES: "/courses",
  COURSE: "/courses/:course_id",
  MODULE: "/courses/:course_id/:module_id/:episode_id",
  LIVESTREAM: "/livestream",
  LIVESTREAM_PLAYER: "/livestream/:livestream_id",
  NEWS: "/news",
  COMICS: "/comics",
  EVENTS: "/events",
  EVENT_PAYMENT: "/events/payment",
  EVENT: "/events/:event_id",
  MONEY_PARENT: "/money/*",
  MONEY_DEFAULT: "/money",
  INVEST: "invest",
  SPEND: "spend",
  PROTECT: "protect",
  TAX: "/protect/tax",
  FILE_ITR: "/protect/tax/file-itr",
  HRA: "/protect/tax/hra",
  LEADERBOARD: "/leaderboard",
  SEARCH: "/search",
  WALLET: "/home/wallet",
  BOOKMARKS: "/home/bookmarks",
  ACTIVITY: "/home/activity/:activity_id",
  MEMBERSHIP: "/home/membership",
  FIRE_CALCULATOR: "/fire-calculator",
  CLEARTAX: "/money/protect/cleartax",
};

export const ONBOARDING_ROUTE_MAPPING: {
  [key: string]: string;
} = {
  user_personal_details: ROUTES.ONBOARDING_PERSONAL_DETAILS,
  user_profile_pic: ROUTES.ONBOARDING_PROFILE_PIC,
  user_professional_details: ROUTES.ONBOARDING_PROFESSIONAL_DETAILS,
  user_socials: ROUTES.ONBOARDING_SOCIALS,
};
